<template>
    <div :class="'img-' + size" class="custom-icon">
        <svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M16 94h-4C6.477 94 2 89.523 2 84V35c0-5.523 4.477-10 10-10m0 0h80.332a10 10 0 017.666 3.578l12.935 15.438m0 0l12.732 15.197A10 10 0 01128 65.636V84c0 5.523-4.477 10-10 10h-4.538M86.44 94H43.231M69 25v32h54" class="path" stroke="#0C2340"/><path d="M30 79c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13zm70 0c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13z" class="highlight" stroke="#00BBDC"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>